import type { AppLocale } from '../messages';

/**
 * Строки участка «feedback»: что человек видит, когда что-то не получилось или ещё не готово —
 * ошибки разблокировки и списка заблокированных (аудит 2026-10-17, часть 4).
 * Свой файл у каждого участка, а не общий `messages.ts` на 4300 строк: участки правятся
 * параллельно, и общий файл давал бы конфликт на каждой новой строке.
 * Ключ добавляется во все четыре словаря — `en` задаёт набор, остальные проверяются типом.
 *
 * <p>Строки экранов, которые грузятся лениво (плашка связи, микрофон и камера, неотправленное,
 * карточка профиля в чате), живут в `feedbackScreens.ts`: этот словарь целиком входит в основной веб-бандл.
 */
const en = {
  unblockFailed: 'Could not unblock',
  blockedListLoadFailed: 'Could not load the blocked list',
} as const satisfies Record<string, string>;

export type FeedbackMessageKey = keyof typeof en;

export const feedbackMessages: Record<AppLocale, Record<FeedbackMessageKey, string>> = {
  en,
  ru: {
    unblockFailed: 'Не удалось разблокировать',
    blockedListLoadFailed: 'Не удалось загрузить список заблокированных',
  },
  sr: {
    unblockFailed: 'Deblokiranje nije uspelo',
    blockedListLoadFailed: 'Učitavanje liste blokiranih nije uspelo',
  },
  fr: {
    unblockFailed: 'Impossible de débloquer',
    blockedListLoadFailed: 'Impossible de charger la liste des contacts bloqués',
  },
};
